import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LeadsProvider } from './contexts/LeadsContext';
import { Sidebar } from './components/Sidebar';
import { TopBar } from './components/TopBar';
import { Overview } from './pages/Overview';
import { Leads } from './pages/Leads';
import { LeadDetail } from './pages/LeadDetail';
import { Loans } from './pages/Loans';
import { LoanDetail } from './pages/LoanDetail';
import { FollowUps } from './pages/FollowUps';
import { Reports } from './pages/Reports';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mjpvpebsrcfa">
      <LeadsProvider data-id="element-1" data-mp="31aqfuglwour9">
      <div className="flex h-full min-h-screen w-full bg-canvas text-ink" data-id="element-2" data-mp="31b8lu4ydencd">
        <Sidebar data-id="element-3" data-mp="2wk09b01quluz" />
        <div className="flex min-w-0 flex-1 flex-col" data-id="element-4" data-mp="2wjgrrkg09zhh">
          <TopBar data-id="element-5" data-mp="2whx9joashed2" />
          <main className="flex-1 overflow-y-auto px-4 py-5 sm:px-6" data-id="element-6" data-mp="28ufp6dtutik4">
            <Routes data-id="element-7" data-mp="28sl48zil1qg1">
              <Route path="/" element={<Overview data-id="element-9" data-mp="23vuokdaowwv5" />} data-id="element-8" data-mp="28s2ynca15zvg" />
              <Route path="/leads" element={<Leads data-id="element-11" data-mp="23t8i6gzjcnei" />} data-id="element-10" data-mp="23ujk0b9f7l2z" />
              <Route path="/leads/:leadId" element={<LeadDetail data-id="element-13" data-mp="3iiwaeb4natww" />} data-id="element-12" data-mp="3ik7gwiph6frp" />
              <Route path="/loans" element={<Loans data-id="element-15" data-mp="3mlawr57iwbsx" />} data-id="element-14" data-mp="3ihv22ef0kliv" />
              <Route path="/loans/:loanId" element={<LoanDetail data-id="element-17" data-mp="3mjq45l4rr2xp" />} data-id="element-16" data-mp="3mkrgru1fnxhj" />
              <Route path="/follow-ups" element={<FollowUps data-id="element-19" data-mp="3rdaselgk8ijp" />} data-id="element-18" data-mp="3rcj6618urx63" />
              <Route path="/reports" element={<Reports data-id="element-21" data-mp="5ygolyg4xb6" />} data-id="element-20" data-mp="3rd18nfm3z7mg" />
            </Routes>
          </main>
        </div>
      </div>
      </LeadsProvider>
    </BrowserRouter>;
}